import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductFilterSidebarComponent} from './product-filter-sidebar/product-filter-sidebar.component';
import {FilterConfigSidebarComponent} from './filter-config-sidebar/filter-config-sidebar.component';
import {ColorFilterConfigComponent} from './filter-config-sidebar/configurations/color-filter-config/color-filter-config.component';
import {DoubleRangeSliderComponent} from './filter-config-sidebar/configurations/double-range-slider/double-range-slider.component';
import {FilterConfigSubContentComponent} from './filter-config-sidebar/configurations/filter-config-sub-content/filter-config-sub-content.component';
import {NormalFilterConfigComponent} from './filter-config-sidebar/configurations/normal-filter-config/normal-filter-config.component';
import {RangeFilterConfigComponent} from './filter-config-sidebar/configurations/range-filter-config/range-filter-config.component';
import {FormsModule} from '@angular/forms';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {SingleFilterConfigComponent} from './filter-config-sidebar/configurations/single-filter-config/single-filter-config.component';
import {MatSliderModule} from "@angular/material/slider";
import {NestedFilterConfigComponent} from './filter-config-sidebar/configurations/nested-filter-config/nested-filter-config.component';


@NgModule({
	declarations: [
		ProductFilterSidebarComponent,
		FilterConfigSidebarComponent,
		ColorFilterConfigComponent,
		DoubleRangeSliderComponent,
		FilterConfigSubContentComponent,
		NormalFilterConfigComponent,
		RangeFilterConfigComponent,
		SingleFilterConfigComponent,
		NestedFilterConfigComponent
	],
    imports: [
        CommonModule,
        MatCheckboxModule,
        FormsModule,
        MatSliderModule
    ],
	exports: [
		ProductFilterSidebarComponent,
	],
})
export class ProductFilterSidebarModule {
}
